<div class="order-details-page">
  <div class="order-details-container">
    <umkt-breadcrumb [items]="breadCrump" [separator]="'>'"></umkt-breadcrumb>
    
    <div class="page-header">
      <div class="order-page-title">
        <h1 class="page-title">{{ 'pages.orderDetails.title' | i18n }}</h1>
      </div>
    </div>
    
    <div *ngIf="isLoading">
      <umkt-loading
        [size]="'lg'"
        [isLoading]="isLoading"
        [showText]="true"
        [text]="'pages.orderDetails.loading' | i18n"
        mode="overlay"
      ></umkt-loading>
    </div>
    <div *ngIf="error && !isLoading" class="error-state">
      <p>{{ error }}</p>
    </div>
    <div *ngIf="showCreditRetryBanner" class="order-details-page__card order-details-page__card--before-content">
      <div class="credit-retry-banner" role="status">
        <span class="credit-retry-banner__icon" aria-hidden="true">
          <umkt-icon [icon]="creditRetryBannerIcon" size="lg"></umkt-icon>
        </span>
        <div class="credit-retry-banner__main">
          <div class="credit-retry-banner__text-block">
            <p class="credit-retry-banner__text">{{ 'pages.orderDetails.creditRejectedHintLead' | i18n }}</p>
            <p class="credit-retry-banner__text credit-retry-banner__text--follow">
              {{ 'pages.orderDetails.creditRejectedHintFollowUp' | i18n }}
            </p>
          </div>
          <button type="button" class="credit-retry-banner__cta" (click)="goToCartRetryWithCard()">
            {{ 'pages.orderDetails.retryWithCard' | i18n }}
          </button>
        </div>
      </div>
    </div>
    <umkt-order-content [orderDetails]="orderDetails" *ngIf="!error && !isLoading"></umkt-order-content>
  </div>
</div>